import { ButtonHTMLAttributes, ComponentType } from 'react';

type IconActionButtonTone = 'default' | 'danger' | 'primary' | 'sky' | 'success';

type IconActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ComponentType<{ className?: string }>;
  tone?: IconActionButtonTone;
};

const TONE_CLASS: Record<IconActionButtonTone, string> = {
  default: 'text-secondary-500 hover:bg-primary-50 hover:text-primary-600',
  danger: 'text-secondary-500 hover:bg-red-50 hover:text-red-600',
  primary: 'text-primary-600 hover:bg-primary-50 hover:text-primary-700',
  sky: 'text-secondary-500 hover:bg-sky-50 hover:text-sky-600',
  success: 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm',
};

export function IconActionButton({
  label,
  icon: Icon,
  tone = 'default',
  className = '',
  type = 'button',
  ...props
}: IconActionButtonProps) {
  return (
    <button
      type={type}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${TONE_CLASS[tone]} ${className}`}
      {...props}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
